/**
 * The owner's server refusing voice because the business's AI credits are used up (one-meter, 3 Nov 2026): 402
 * AI_CREDITS_EMPTY, before any provider is asked. Trying again is refused the same way, so the ears say `credits`.
 */
export function isOutOfAiCredits(e) {
  const status = e?.response?.status ?? e?.status;
  const data = e?.response?.data;
  const code = e?.code || data?.code || data?.errorCode;
  return status === 402 || code === 'AI_CREDITS_EMPTY';
}
